import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import 'swiper/css/pagination';
import 'swiper/css';
import MERNCertificate from "../img/MERNCourseImage.jfif";
import javascriptCertification from '../img/JavaScriptCertificate.jpg';
import HackerCertificate from '../img/hackerRankCertificate.png' 
import SeeMore from '../img/seeMore.png'
import { useContext } from "react";
import { themeContext } from "../context";
import { useNavigate } from 'react-router-dom'; 

export default function Certification() {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const themeHook = useTheme();
  const isSmallScreen = useMediaQuery(themeHook.breakpoints.down("md"));
  const navigate = useNavigate();

  const certificates = [
    {
        img: MERNCertificate,
        review: "MERN Fullstack Guide - Udemy",
      },
    {
      img: javascriptCertification,
      review: "Complete JavaScript Course - Udemy",
    },
    {
      img: HackerCertificate,
      review: "Hacker Rank - SQL",
    },
    {
        img: SeeMore,
        review: "See more ...",
      }
  ];

  return (
    <Box id="Certificates" sx={{ mt: 18, mb:15, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
      {/* Heading */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <Typography sx={{ color: darkMode ? 'white' : 'var(--black)', fontSize: '2.5rem', fontWeight: 'bold' }}>
          Completed
        </Typography>
        <Typography sx={{ color: 'var(--orange)', fontSize: '3rem', fontWeight: 'bold' }}>
          Certifications
        </Typography>
      </Box>

      {/* Blur Effects */}
      <Box sx={{ position: 'absolute' }}>
        {isSmallScreen ? (
          <Box sx={{ position: 'absolute', left: '-2rem', top: '7rem', filter: 'blur(4rem)', background: 'var(--purple)', width: '200px', height: '200px', borderRadius: '50%' }}></Box>
        ) : (
          <Box sx={{ position: 'absolute', left: '10rem', top: '7rem', filter: 'blur(4rem)', background: 'var(--purple)', width: '200px', height: '200px', borderRadius: '50%' }}></Box>
        )}
        {isSmallScreen ? (
          <Box sx={{ position: 'absolute', top: '-4rem', left: '-12rem', filter: 'blur(8rem)', background: 'skyblue', width: '200px', height: '200px', borderRadius: '50%' }}></Box>
        ) : (
          <Box sx={{ position: 'absolute', top: '-12rem', left: '-27rem', filter: 'blur(8rem)', background: 'skyblue', width: '200px', height: '200px', borderRadius: '50%' }}></Box>
        )}
      </Box>

      {/* Slider */}
      <Swiper
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{ clickable: true }}
        style={{ width: '100%', height: '55%' }}
      >
        {certificates.map((certificate, index) => (
          certificate.review.includes('See') ? (
              <SwiperSlide style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '450px', cursor: 'pointer' }} 
              onClick={() => navigate('/allCertificates')}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-evenly', padding: 1, width: '30rem', background: 'rgba(255, 255, 255, 0.26)', border: '7px solid var(--blueCard)', boxShadow: 'var(--boxShadow)', borderRadius: '20px' }}>
                  <img src={certificate.img} alt="" style={{ width: '100%', paddingBottom: '1rem' }} />
                  <Typography sx={{ color: 'var(--gray)' }}>{certificate.review}</Typography>
                </Box>
              </SwiperSlide>
          ) : (
            <SwiperSlide key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '450px' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-evenly', padding: 1, width: '30rem', background: 'rgba(255, 255, 255, 0.26)', border: '7px solid var(--blueCard)', boxShadow: 'var(--boxShadow)', borderRadius: '20px' }}>
                <img src={certificate.img} alt="" style={{ width: '100%', paddingBottom: '1rem' }} />
                <Typography sx={{ color: 'var(--gray)' }}>{certificate.review}</Typography>
              </Box>
            </SwiperSlide>
          )
        ))}
      </Swiper>
      <style jsx global>{`
        .swiper-horizontal > .swiper-pagination-bullets {
          bottom: 0px; /* Adjust this value to move the pagination dots down */
        }
        .swiper-pagination-bullet {
          background: orange;
        }
        .swiper-pagination-bullet-active {
          background: darkorange;
        }
      `}</style>
    </Box>
  );
}